var _defs, _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Degradado_sin_nombre_63);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_63",
    x1: 124.98,
    y1: 33.46,
    x2: 375.02,
    y2: 466.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#774adf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#9748be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#bd4697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#d8447a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e94369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ef4363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ef545e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#f08053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2c141"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 500,
    height: 500,
    rx: 250,
    ry: 250
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.6,365.57c.75-3.89,1.36-7.81,2.27-11.66,4.25-17.81,12.32-34,21.47-49.69,3.4-5.83,7.24-11.41,10.61-17.26a8.31,8.31,0,0,0,1-5.36c-5.12-25-3.11-49.53,6.95-72.86,16.33-37.86,44.63-62.52,84.72-73.05A121.87,121.87,0,0,1,272.88,134a7.58,7.58,0,0,0,5.06-1.08c16.89-11.23,34-22.13,52.68-30.18,12.94-5.58,26.21-10,40.51-10.14,25-.23,38.21,17.73,36,40.88-1.71,18.32-8.8,34.86-17.53,50.7-6.12,11.1-13,21.77-19.8,32.5-1.29,2-.75,3.62-.23,5.44A119.88,119.88,0,0,1,371.74,282c-8.19,37.16-29,65.36-62.32,83.74a118.72,118.72,0,0,1-74.76,14,191.59,191.59,0,0,1-21.27-4.53,7.09,7.09,0,0,0-6.24.95c-14.56,9.39-29.52,18.15-45.9,23.93-8.25,2.91-16.94,4.55-25.42,6.78a15,15,0,0,0-1.42.5h-9.84c-.78-.18-1.55-.42-2.34-.53-10.53-1.34-19.18-6-24.34-15.42-2.57-4.69-3.58-10.25-5.29-15.41ZM257.86,158.2c-24.12-.22-39.82,3.6-54.4,11.47-37.88,20.43-58.11,62.16-50.19,104.55,5.82,31.08,23.25,54,51,69.25,2,1.1,3.28.95,5.12-.37a588,588,0,0,0,71.85-61.46,575.27,575.27,0,0,0,56.37-64.9,3.85,3.85,0,0,0,.48-3.42c-4.36-7-8.24-14.51-13.57-20.73C305.09,170,280.13,158.69,257.86,158.2Zm89.75,88.71A654.29,654.29,0,0,1,239.05,353.7C293.2,362,353.65,315.28,347.61,246.91Zm7.78-56.65c.37-.22.62-.27.71-.42,9.33-15.08,18-30.53,22.78-47.71a66,66,0,0,0,2-15.43c.18-5.1-2.08-7.32-7.09-7.87-6.54-.71-12.82.87-19,2.81-16.82,5.29-32,14-46.89,23.18a5.19,5.19,0,0,0-.84,1A123.68,123.68,0,0,1,355.39,190.26Zm-215,125.59c-.35.3-.68.45-.8.7C134,328,127.91,339.32,123,351.1c-2.53,6.11-3.31,13-4.21,19.69-.81,5.95,1.29,9,5.92,9.71a32.11,32.11,0,0,0,9.13.08c13.05-1.89,24.82-7.43,36.45-13.26,3.85-1.93,7.56-4.16,11.69-6.45A126.53,126.53,0,0,1,140.34,315.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.44,221.55a39.94,39.94,0,0,0-55.06-.1l-18.26-18.13c22.07-23.87,65.53-26.78,91.64-.08Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo12);
export default __webpack_public_path__ + "static/media/logo-12.7e625d7e5fc1c2813119b5908ff73c2f.svg";
export { ForwardRef as ReactComponent };